// The assistant's display name in the owner dashboard. The canonical copy is
// ASSISTANT_NAME in jonathan/brand.py; tests/test_brand.py fails if they differ.
export const ASSISTANT_NAME = 'Mabel';
export const ASSISTANT_INITIAL = ASSISTANT_NAME[0];
